import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function MobileLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('mobile_token');
    if (token) {
      navigate('/m', { replace: true });
    }
  }, [navigate]);

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      setError('아이디와 비밀번호를 입력해주세요');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const r = await axios.post('/api/mobile/login', { username, password });
      localStorage.setItem('mobile_token', r.data.token);
      localStorage.setItem('mobile_username', r.data.username);
      navigate('/m', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || '로그인에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', padding: '20px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: '360px', background: '#fff', borderRadius: '16px', padding: '32px 24px', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a1a' }}>진하유통</div>
          <div style={{ fontSize: '13px', color: '#999', marginTop: '4px' }}>모바일 관리자</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            placeholder="아이디"
            style={{ fontSize: '16px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd', boxSizing: 'border-box' }}
          />
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            placeholder="비밀번호"
            style={{ fontSize: '16px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd', boxSizing: 'border-box' }}
          />
          {error && <div style={{ fontSize: '13px', color: '#E24B4A' }}>{error}</div>}
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{ fontSize: '16px', padding: '14px', borderRadius: '10px', border: 'none', background: loading ? '#ccc' : '#1D9E75', color: '#fff', fontWeight: '500', marginTop: '8px' }}
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
          <div style={{ fontSize: '11px', color: '#aaa', textAlign: 'center', marginTop: '8px' }}>
            로그인 상태가 30일간 유지됩니다
          </div>
        </div>
      </div>
    </div>
  );
}
